import styled from "styled-components";

const ImportOrderProducts = () : JSX.Element => {
  return (
    <div>
      <SubTitle>Import Logistics</SubTitle>
      <Description>The excel needs to have the following columns in that specific order:</Description>
      <Table>
        <tbody>
          <tr>
            <StyleTd style={{ fontWeight: 'bold' }}>
              [A] <b>Barcode Piece</b>
            </StyleTd>
            <StyleTd>used to match products.</StyleTd>
          </tr>
          <tr>
            <StyleTd style={{ fontWeight: 'bold' }}>
              [B] <b>Barcode Carton</b>
            </StyleTd>
            <StyleTd>NOT used for search.</StyleTd>
          </tr>
          <tr>
            <StyleTd style={{ fontWeight: 'bold' }}>
              [C] <b>Name</b>
            </StyleTd>
            <StyleTd>NOT used for search.</StyleTd>
          </tr>
          <tr>
            <StyleTd style={{ fontWeight: 'bold' }}>
              [D] <b>Expiration Date</b>
            </StyleTd>
            <StyleTd>
              Currently it is only recorded in a "Note". format DD/MM/YYYY. Ex: 13/04/2022.
            </StyleTd>
          </tr>
          <tr>
            <StyleTd style={{ fontWeight: 'bold' }}>
              [E] <b>Order (cartons)</b>
            </StyleTd>
            <StyleTd>Integer</StyleTd>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

const Table = styled.div`
  border: 1px solid #fff;
  border-radius: 10px;
  overflow: hidden;
`;

const StyleTd = styled.td`
  width: 300px;
  border: 1px solid #fff;
  padding: 7px;
`;

const Description = styled.p`
  text-align: center;
  margin-bottom: 42px;
`;

const SubTitle = styled.h1`
  text-align: center;
  margin-bottom: 50px;
  color: #642b26;
  font-size: 20px;
  font-weight: bold;
  padding: 0;
`;

export default ImportOrderProducts;

